import * as Configuration from '../../../app.constants.js';



CatalogsController.$inject = ['$scope', '$http', 'AlertingFactory', 'TopToolbarFactory', 
                              'company'];
export function CatalogsController($scope, $http, AlertingFactory, TopToolbarFactory, company)
{
  init();
  $scope.connectedBusinesses = [];
  function init() {
    TopToolbarFactory.setTitleTranslation('parameters/links_menu/catalogs', $scope);
    TopToolbarFactory.setButton('menu/settings/add-business-manager', addBusinessManager, $scope);
  }
  
  function addBusinessManager() {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + company.id + '/add-business-manager';
    // primitives are not converted automatically to json by $http
    $http.post(url, angular.toJson('facebook')).then(function success(response) {
      window.location.href = response.data;
    }, function error(response) {
      AlertingFactory.alertHTTPError(response);
    });
  }
}
